import { connect } from "metabase/redux";
import type { State } from "metabase/redux/store";
import { getUser } from "metabase/selectors/user";
import { checkNotNull } from "metabase/utils/types";

import { updateUser } from "../../actions";
import UserProfileForm from "../../components/UserProfileForm";
import { getIsSsoUser, getLocales } from "../../selectors";

const mapStateToProps = (state: State) => ({
  user: checkNotNull(getUser(state)),
  locales: getLocales(state),
  // IAS overlay: force the SSO branch so `UserProfileForm` renders only the
  // language selector — the first name / last name / email fields (and their
  // submit path) belong to the amelia identity provider, not Metabase. The
  // upstream selector still runs so plugin-provided predicates keep working
  // if IAS is ever swapped back to Metabase-managed auth.
  isSsoUser: getIsSsoUser(state) || true,
});

const mapDispatchToProps = {
  onSubmit: updateUser,
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default connect(mapStateToProps, mapDispatchToProps)(UserProfileForm);
